import * as React from 'react';
import { Component } from 'react';
import { Tournament } from 'Src/models/tournament';
import {
  SAILING_GROUP_STAGES,
  TOURNAMENT_GROUP_TAG_MAPPING,
  TOURNAMENT_GROUP_TAG_MAPPING_REVERSE
} from 'Src/consts/tournament';
import { Form, Formik } from 'formik';
import { Button } from 'Src/components/Button/Button';
import { isGroupStageExist } from 'Src/helpers/tournament/tournament';
import { Switch } from 'Src/components/Switch/Switch';

interface Props {
  tournament: Tournament;
  onCancel: () => void;
  onSubmit: (data) => void;
}

export class TournamentSailingGroupsForm extends Component<Props> {
  renderGroups(groups: string[], values, setFieldValue): React.ReactNode {
    return (
      <div className="tournamentDefaultGroupsForm__chips">
        {groups.map((group, index) => (
          <div key={`group_${index}`} style={{ display: 'flex' }}>
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                checked={values[group]}
                onChange={() => setFieldValue(group, !values[group])}
                className="custom-control-input"
                id={`switch_group_${group}`}
              />
              <label className="custom-control-label" htmlFor={`switch_group_${group}`}>
                {TOURNAMENT_GROUP_TAG_MAPPING[group]}
              </label>
            </div>
          </div>
        ))}
      </div>
    );
  }

  getTournamentGroups(): string[] {
    const { tournament } = this.props;
    const { customGroups, stages: groupsDeprecated } = tournament;

    const customGroupsFiltered = customGroups
      .filter(customGroup => {
        const customGroupName = customGroup.name;
        const customGroupNameMapped = TOURNAMENT_GROUP_TAG_MAPPING_REVERSE[customGroupName];

        return typeof customGroupNameMapped !== 'undefined';
      })
      .map(customGroup => {
        const customGroupName = customGroup.name;
        const customGroupNameMapped = TOURNAMENT_GROUP_TAG_MAPPING_REVERSE[customGroupName];
        return customGroupNameMapped;
      });

    return [...groupsDeprecated, ...customGroupsFiltered];
  }

  getGroupValue(group): boolean {
    const tournamentGroups = this.getTournamentGroups();
    const tournamentGroupIndex = tournamentGroups.findIndex(tournamentGroup => tournamentGroup === group);

    return tournamentGroupIndex !== -1;
  }

  getGroupsObject(groupList) {
    let groupsObject = {};

    groupList.forEach(group => {
      groupsObject[group] = this.getGroupValue(group);
    });

    return groupsObject;
  }

  getSailingGroups() {
    const { tournament } = this.props;

    let groups = {};

    if (isGroupStageExist(tournament)) {
      const groupGroups = [...SAILING_GROUP_STAGES];

      const groupsObject = this.getGroupsObject(groupGroups);
      groups = { ...groups, ...groupsObject };
    }

    return groups;
  }

  renderAllGroups(values, setFieldValue): React.ReactNode {
    const { tournament } = this.props;
    let groupAndQualifier = [];

    if (isGroupStageExist(tournament)) {
      groupAndQualifier.push(
        <div key="group_stage" className="mb-3 mt-3 font-weight-bold">
          Group Stage
        </div>
      );
      groupAndQualifier.push(this.renderGroups(SAILING_GROUP_STAGES, values, setFieldValue));
    }

    let playoffAndFinal = [];

    return (
      <div className="row">
        <div className="col-md-6">{groupAndQualifier}</div>
        <div className="col-md-6">{playoffAndFinal}</div>
      </div>
    );
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <Formik
              initialValues={this.getSailingGroups()}
              onSubmit={values => {
                this.props.onSubmit(values);
              }}
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <div className="form-group form-check">
                    {this.renderAllGroups(values, setFieldValue)}
                    <div className="tournamentDefaultGroupsForm__actions">
                      <Button
                        onClick={this.props.onCancel}
                        text={'Cancel'}
                        customClass={'tournamentDefaultGroupsForm__cancel'}
                      />
                      <button type="submit" className="tournamentDefaultGroupsForm__save">
                        Save groups
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    );
  }
}
